import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

// Types
import { IPlanInfoTableProps } from '../planSummary.types';

// Styles
import {
    StyledDd,
    StyledDl,
    StyledDt,
    StyledPlanSectionDataContainer,
    StyledSpan,
    StyledWrappedDt,
} from '../plansummary.styled';

// Components
import { ConditionalRendering } from '../../../../components/common/conditional-rendering';

// Constants
import { PLAN_TYPE } from '../../../../modules/custom-grouping/modals/modalTypes';

const PlanInfoTable = memo(({ plan }: IPlanInfoTableProps) => (
    <StyledPlanSectionDataContainer as="div" data-testid="plan-info-table">
        <StyledDl>
            <StyledDt as="dt" data-testid="plan-type-label">
                <StyledSpan>
                    <FormattedMessage id="plansummary.plantype" />
                </StyledSpan>
                <span>:</span>
            </StyledDt>
            <StyledDd as="dd" data-testid="plan-type-value">
                {plan.planType}
            </StyledDd>
            <StyledWrappedDt as="dt" data-testid="office-visit-label">
                <StyledSpan>
                    <FormattedMessage id={`plansummary.${plan.typeOfPlan.toLowerCase()}.officevisit`} />
                </StyledSpan>
                <span>:</span>
            </StyledWrappedDt>
            <StyledDd as="dd" data-testid="office-visit-value">
                <ConditionalRendering isTrue={!!plan.officeVisit}>
                    <span dangerouslySetInnerHTML={{ __html: plan.officeVisit }} />
                </ConditionalRendering>
                <ConditionalRendering isTrue={!plan.officeVisit}>
                    <FormattedMessage id="plansummary.na" />
                </ConditionalRendering>
            </StyledDd>
            <ConditionalRendering isTrue={plan.typeOfPlan.toUpperCase() === PLAN_TYPE.HEALTH}>
                <>
                    <StyledDt as="dt" data-testid="generic-medications-label">
                        <StyledSpan>
                            <FormattedMessage id="plansummary.genericmedications" />
                        </StyledSpan>
                        <span>:</span>
                    </StyledDt>
                    <StyledDd as="dd" data-testid="generic-medications-value">
                        <span dangerouslySetInnerHTML={{ __html: `${plan.genericMedications}` }} />
                    </StyledDd>
                </>
            </ConditionalRendering>

            <StyledDt as="dt" data-testid="deductible-label">
                <StyledSpan>
                    <FormattedMessage id={`plansummary.${plan.typeOfPlan.toLowerCase()}.deductible`} />
                </StyledSpan>
                <span>:</span>
            </StyledDt>
            <StyledDd as="dd" data-testid="deductible-value">
                {plan.deductible}
            </StyledDd>

            <StyledDt as="dt" data-testid="max-out-pocket-label">
                <StyledSpan>
                    <FormattedMessage id={`plansummary.${plan.typeOfPlan.toLowerCase()}.maxoutofpocket`} />
                </StyledSpan>
                <span>:</span>
            </StyledDt>
            <StyledDd as="dd" data-testid="max-out-pocket-value">
                {plan.oopMax}
            </StyledDd>
        </StyledDl>
    </StyledPlanSectionDataContainer>
));

PlanInfoTable.displayName = 'PlanInfoTable';
export default PlanInfoTable;
